import Search from '@admin/components/search'
import PropTypes from 'prop-types'
import Results from './results'
import React from 'react'

class Icons extends React.PureComponent {

  static propTypes = {
    device: PropTypes.object,
    root_endpoint: PropTypes.string,
    website: PropTypes.object,
    onBack: PropTypes.func,
    onNavigate: PropTypes.func,
    onSettings: PropTypes.func
  }

  _handleChoose = this._handleChoose.bind(this)

  render() {
    return <Search { ...this._getSearch() } />
  }

  _getSearch() {
    const { root_endpoint } = this.props
    return {
      endpoint: `/api/admin${root_endpoint}/icons`,
      layout: Results,
      label: 'Icon',
      valueKey: null,
      textKey: 'title',
      onChange: this._handleChoose,
      props: {
        type: 'icon'
      }
    }
  }

  _handleChoose(item) {
    this.props.onSettings(null)
    this.props.onNavigate(`items/${item.id}`)
  }

}

export default Icons
